import { BaseConfig } from '../ServiceConfig';

export interface FileConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.FileServiceConfigData';
  url: string;
}

export const FileConfigurationFields: (keyof FileConfiguration)[] = [
  'url',
];

export const BlankFileConfiguration: FileConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.FileServiceConfigData',
} as FileConfiguration;
